/**
 * Unit Model Interface
 * Framework-agnostic TypeScript interface
 */

export interface Unit {
  id?: number;
  unit_id?: number;
  unit_name: string;
  unit?: string;
  is_default?: number | boolean;
  created_at?: string;
  updated_at?: string;
  active?: number | boolean;
  program_id?: number;
}

export interface UnitFormData {
  id?: number;
  unit_id?: number;
  unit_name: string;
  is_default?: number | boolean;
}

export interface UnitApiResponse {
  data: {
    units: Unit[];
  };
  message?: string;
  success?: boolean;
}
